<template>
  <div class="flex flex-col gap-6">
    <form class="flex flex-col gap-4" novalidate @submit.prevent="() => submit()">
      <div class="flex flex-col gap-1.5">
        <ui-label for="forgotten-password-email">{{ tr('E-mail address') }}</ui-label>
        <ui-input
          id="forgotten-password-email"
          v-model="email"
          type="email"
          autocomplete="username"
          :placeholder="tr('you@gmail.com')"
        />
      </div>

      <ui-button
        type="submit"
        size="lg"
        class="mt-2 w-full"
        :disabled="isLoading"
      >
        <loader-circle-icon v-if="isLoading" class="animate-spin" />
        {{ tr('Send') }}
      </ui-button>
    </form>

    <router-link to="/auth/login" class="text-sm font-semibold text-foreground underline decoration-muted-foreground/50 underline-offset-4 hover:text-primary">
      {{ tr('Back to login') }}
    </router-link>
  </div>
</template>

<script>
import { LoaderCircle } from '@lucide/vue';

import { UnauthorizedError } from '@/errors';
import AuthService from '@/services/Auth.js';
import { isValidEmail } from '@/utils/validators';

export default {
  name: 'ForgottenPasswordView',
  components: {
    LoaderCircleIcon: LoaderCircle,
  },
  data() {
    return {
      isLoading: false,
      email: '',
    };
  },
  methods: {
    resetForm() {
      this.email = '';
    },
    submit() {
      if (!this.validate()) {
        return;
      }

      this.isLoading = true;
      AuthService.forgottenPassword(this.email)
        .then(resp => {
          this.resetForm();
          this.$toast.success(this.tr('The link to reset the password has been sent to the specified email address.'));

          return resp;
        })
        .catch(err => {
          if (err instanceof UnauthorizedError) {
            this.$toast.error(this.tr('Invalid e-mail given!'));
          }
          else {
            this.error(err);
          }
        })
        .finally(() => this.isLoading = false);
    },
    validate() {
      this.$toast.clear();

      if (!this.email) {
        this.$toast.error(this.tr('E-mail cannot be empty!'));
        return false;
      }
      if (!isValidEmail(this.email)) {
        this.$toast.error(this.tr('E-mail provided has an incorrect format!'));
        return false;
      }

      return true;
    },
  },
};
</script>
